import { useEffect, useState } from "react";
import { ShoppingBag, X } from "lucide-react";

const NAMES = [
  "Aisyah R.", "Faizal A.", "Nurul H.", "Ahmad Z.", "Siti M.", "Hafiz B.",
  "Amirah S.", "Zul Faliq", "Rahmah K.", "Danial I.", "Farah A.", "Iman N.",
  "Khadijah L.", "Syafiq T.", "Aina R.", "Mustaqim H.", "Zulaikha M.",
];
const CITIES = [
  "Kuala Lumpur", "Shah Alam", "Johor Bahru", "Ipoh", "Kuantan", "Melaka",
  "Kota Bharu", "Kuching", "Kota Kinabalu", "Seremban", "Alor Setar",
  "Puchong", "Cyberjaya", "Petaling Jaya", "Kajang", "Bangi", "Klang",
];
const TIME_LABELS = [
  "baru sahaja", "5 minit lalu", "15 minit lalu", "30 minit lalu",
  "45 minit lalu", "1 jam lalu", "2 jam lalu", "3 jam lalu",
  "5 jam lalu", "8 jam lalu", "12 jam lalu", "1 hari lalu",
  "2 hari lalu", "3 hari lalu", "5 hari lalu", "1 minggu lalu",
];

const rand = (arr) => arr[Math.floor(Math.random() * arr.length)];

export const PurchasePopup = () => {
  const [current, setCurrent] = useState(null);
  const [products, setProducts] = useState([]);

  useEffect(() => {
    // Fetch product list once so notifications use real products
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/products`)
      .then((r) => r.json())
      .then((d) => setProducts(d))
      .catch(() => {});
  }, []);

  useEffect(() => {
    if (products.length === 0) return;

    let showTimeout;
    let hideTimeout;
    let loop;

    const showOne = () => {
      const item = {
        name: rand(NAMES),
        city: rand(CITIES),
        product: rand(products).name,
        time: rand(TIME_LABELS),
      };
      setCurrent(item);
      hideTimeout = setTimeout(() => setCurrent(null), 5500);
    };

    // First appearance after 6s (post-popup)
    showTimeout = setTimeout(() => {
      showOne();
      loop = setInterval(showOne, 14000);
    }, 6000);

    return () => {
      clearTimeout(showTimeout);
      clearTimeout(hideTimeout);
      clearInterval(loop);
    };
  }, [products]);

  if (!current) return null;

  return (
    <div
      data-testid="purchase-popup"
      className="fixed bottom-4 left-4 z-[9997] max-w-[340px] animate-fade-up"
    >
      <div className="flex items-start gap-3 bg-white rounded-2xl p-4 pr-8 border border-[rgba(28,28,28,0.08)] shadow-[0_18px_45px_rgba(28,28,28,0.14)]">
        <div className="w-10 h-10 rounded-full bg-[#E07A5F]/12 text-[#E07A5F] flex items-center justify-center shrink-0">
          <ShoppingBag className="w-4 h-4" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-[13px] text-[#1C1C1C] leading-snug">
            <span className="font-semibold">{current.name}</span>
            <span className="text-[#4A4A4A]"> dari {current.city}</span>
            <br />
            baru sahaja menempah <span className="font-semibold text-[#E07A5F]">{current.product}</span>
          </p>
          <div className="flex items-center gap-1.5 mt-1.5">
            <span className="w-1.5 h-1.5 rounded-full bg-[#81B29A] animate-pulse" />
            <span className="text-[10px] tracking-wider uppercase font-bold text-[#81B29A]">
              {current.time}
            </span>
          </div>
        </div>
        <button
          onClick={() => setCurrent(null)}
          aria-label="Tutup"
          className="absolute top-3 right-3 w-6 h-6 rounded-full text-[#4A4A4A] hover:bg-[#F4F1EA] flex items-center justify-center"
        >
          <X className="w-3.5 h-3.5" />
        </button>
      </div>
    </div>
  );
};
